import * as THREE from 'three';



export const mapRange = (value, inputMin, inputMax, outputMin, outputMax) => {
    return ((value - inputMin) / (inputMax - inputMin)) * (outputMax - outputMin) + outputMin;
};

export const invokeAfterDelay = (callback, delay) => {
    let start = performance.now();
    const tick = () => {
        if (performance.now() - start >= delay * 1000) {
            callback();
        } else {
            requestAnimationFrame(tick);
        }
    };
    requestAnimationFrame(tick);
};

export const GetLookAtFromRotation = (object) => {
    const direction = new THREE.Vector3();
    object.updateMatrixWorld(true);
    object.getWorldDirection(direction); // 현재 카메라의 방향 벡터

    // 카메라 위치 + 방향 벡터 = LookAt 위치
    const lookAtTarget = new THREE.Vector3().addVectors(object.position, direction);

    return lookAtTarget;
};

export const hasParentWithName = (object, parentName) => {
    let found = false;
    object.traverseAncestors(parent => {
        if (parent.name === parentName) {
            found = true;
        }
    });
    return found;
};